import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import ApiService from "../../core/service/api-service";
import DataGrid, { getGridBodyHeight } from "../../core/components/data-grid/DataGrid";
import { useDataGrid } from "../../core/components/data-grid/DataGridContext";
import reAssessmentColumns from "./ReAssessmentColumns";
import { toReAssessmentQuery } from "./re-assessment-filter-query";

export default function ReAssessmentGrid() {
    const { t } = useTranslation();
    const { setDataGridProps, queryModel, setData, setPaginationResult, loadCount } = useDataGrid();

    const columns = useMemo(() => reAssessmentColumns(t), []);

    const initDataGrid = async () => {
        const query = toReAssessmentQuery(queryModel);
        const response = await ApiService.ReAssessment.GetDataGrid(query);

        if (!response.success)
            return;

        setData(response.data);
        setPaginationResult(response.pagination);

        // Sayaç ayrı istek, sayfa çizildikten SONRA (rapor/faturalandırma ekranlarıyla aynı desen).
        loadCount(
            (exact) => ApiService.ReAssessment.GetDataGridCount(query, exact),
            JSON.stringify(query.filter)
        );
    }

    useEffect(() => {
        if (window.reAssessmentGridKey !== queryModel.updateKey) {
            window.reAssessmentGridKey = queryModel.updateKey;
            initDataGrid();
        }
    }, [queryModel.updateKey]);

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns,
            virtual: true,
            antdTableProps: {
                scroll: {
                    x: columns.map(x => x.width || 0).reduce((a, b) => a + b, 0),
                    y: getGridBodyHeight()
                },
                tableLayout: 'fixed'
            },
        })
    }, []);

    return <DataGrid name={'re-assessment'} />
}
